<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style">
    <form [formGroup]="formQuotation">
      <div class="col-lg-12 me-1 me-lg-0">
        <div class="row mt-1">
          <div class="col-lg-5 col-md-4 col-sm-4 col-6">
            <app-custom-select formControlName="conceptIdTypeEquipment" [labelText]="'Tipo Equipo'"
              [list]="listTypesEquipment" [required]="true"
              (onChangeSelect)="getTypeEquipment($event)"></app-custom-select>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-6">
            <app-custom-input-decimal formControlName="mountingValue" [labelText]="'Vr.Montaje'"
              [disabled]="true"></app-custom-input-decimal>
          </div>
          <div class="col-lg-5 col-md-4 col-sm-4 col-6">
            <app-custom-select formControlName="conceptIdTypeBussiness1" [labelText]="'Tipo Negocio 1'"
              [list]="listTypesBussinesses1" [required]="true"
              (onChangeSelect)="getTypeBussiness1($event)"></app-custom-select>
          </div>
          <div class="col-lg-5 col-md-4 col-sm-4 col-6">
            <app-custom-select formControlName="conceptIdTypeBussiness2" [labelText]="'Tipo Negocio 2'"
              [list]="listTypesBussinesses2" [required]="true"
              (onChangeSelect)="getTypeBussiness2($event)"></app-custom-select>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-2 col-6">
            <app-custom-input-text formControlName="paymentMethod" [labelText]="'Método Pago'" [maxLength]="70">
            </app-custom-input-text>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-2 col-6">
            <app-custom-input-text formControlName="deliveryTime" [labelText]="'Tiempo Entrega'" [maxLength]="70">
            </app-custom-input-text>
          </div>
          <div class="col-lg-6 col-md-4 col-sm-4 col-12">
            <app-custom-input-text formControlName="contact" [labelText]="'Contacto'" [maxLength]="70">
            </app-custom-input-text>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-4 col-6">
            <app-custom-input-text formControlName="phone1" [labelText]="'Teléfono 1'" [maxLength]="15">
            </app-custom-input-text>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-4 col-6">
            <app-custom-input-text formControlName="phone2" [labelText]="'Teléfono 2'" [maxLength]="15">
            </app-custom-input-text>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-12">
            <app-custom-input-text formControlName="addressConstructionSite" [labelText]="'Dirección Obra'"
              [maxLength]="70">
            </app-custom-input-text>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-12">
            <app-custom-input-text formControlName="email" [labelText]="'Correo'" [maxLength]="70">
            </app-custom-input-text>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-6 col-12">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
              [autoResize]="false" [maxLength]="250"></app-custom-textarea>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-6 col-12">
            <app-custom-textarea formControlName="observationCommercial" [labelText]="'Observación Comercial'"
              [autoResize]="false" [rows]="1"></app-custom-textarea>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
            <app-custom-checkbox formControlName="showConsolidatedEquipmentAvailability"
              [labelText]="'Incluir Disp.Consol.'">
            </app-custom-checkbox>
          </div>
          <div class="col-lg-12 col-12 mt-2 d-flex justify-content-end gap-2">
            <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
              (onClick)="close()"></app-custom-button>
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              [disabled]="!permissionUpdatable || quotationContract.quotationStateId != quotationStateOpen"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>